import * as actions from '../utils/Constants';
import { apiGet, apiDeleteAndThen, apiDeleteWithBodyAndThen } from '../utils/Api';

const apiSession = `${process.env.REACT_APP_API_HOST}api/session/`;
const apiTraining = `${process.env.REACT_APP_API_HOST}api/training/`;
const apiTrainings = `${process.env.REACT_APP_API_HOST}api/trainings`;

const getTrainingsApi = (sessionId) => apiGet(`${apiSession}${sessionId}/trainings`);

export const getTrainings = (sessionId) => ({
    type: actions.GET_TRAININGS,
    payload: getTrainingsApi(sessionId)
});

export const getTraining = (id) => {

    return dispatch => {

        dispatch({
            type: actions.GET_TRAINING,
            payload: apiGet(apiTraining + id)
        });

        dispatch({
            type: actions.GET_TRAINING_FACULTY,
            payload: apiGet(`${process.env.REACT_APP_API_HOST}api/training/${id}/faculty`)
        });

        dispatch({
            type: actions.GET_TRAINING_CONTACTS,
            payload: apiGet(`${process.env.REACT_APP_API_HOST}api/training/${id}/contacts`)
        });

        dispatch({
            type: actions.GET_TRAINING_JOURNAL,
            payload: apiGet(`${process.env.REACT_APP_API_HOST}api/training/${id}/journal`)
        });
        
        dispatch({
            type: actions.GET_TRAINING_DOCUMENTS,
            payload: apiGet(`${process.env.REACT_APP_API_HOST}api/training/${id}/documents`)
        });

        dispatch({
            type: actions.GET_TRAINING_CURRICULUM,
            payload: apiGet(`${process.env.REACT_APP_API_HOST}api/training/${id}/curriculum`)
        });

        dispatch({
            type: actions.GET_TRAINING_PROGRAMS,
            payload: apiGet(`${process.env.REACT_APP_API_HOST}api/training/${id}/programs`)
        });

    }
}

export const getPOCs = (sessionId) => ({
    type: actions.GET_TRAININGS_POCS,
    payload: apiGet(`${apiSession}${sessionId}/trainings/pocs`)
});

export const deleteTraining = (id, sessionId) => ({
    type: actions.DELETE_TRAINING,
    payload: apiDeleteAndThen(apiTraining + id, getTrainingsApi(sessionId))
});

export const deleteTrainings = (ids, sessionId) => ({
    type: actions.DELETE_TRAINING,
    payload: apiDeleteWithBodyAndThen(apiTrainings, ids, () => getTrainingsApi(sessionId))
});
export const newTraining = (startDate, endDate) => ({
    type: actions.NEW_TRAINING,
    payload: {startDate, endDate}
})

export const updateSelectedPrograms = (selected) => ({
    type: actions.UPDATE_TRAININGS_SELECTED_PROGRAMS,
    payload: selected
})

export const updateSelectedTrainingTypes = (selected) => ({
    type: actions.UPDATE_TRAININGS_SELECTED_TRAININGTYPES,
    payload: selected
})
